import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  width: 100vw;
`

export const HTTPStatus = styled.div`
  font-size: 64px;
  font-weight: 700;
`

export const ErrorMessage = styled.div`
  font-size: 24px;
`
